import { HtmlData, HtmlTemplate, ServerResponse } from './interfaces/app.interface';
import { Guid } from './utils/Guid';


function initAppContent(): void {
      const iframe = document.getElementById('content-iframe') as HTMLIFrameElement
      apiRequest().then(res => res.json())
            .then((res: ServerResponse) => {
                  setIframeContent(res.Data, iframe)
                  iframe.addEventListener('load', () => {
                        setIframeHeightFromIframeContentHeight(iframe)

                  })
            })
            .catch(err => console.log(err))
}

function setIframeContent(htmlData: HtmlData, iframe: HTMLIFrameElement): void {
      const html: HtmlTemplate = htmlData.GetRegistrationHtmlPage[0]
      iframe.srcdoc = html.TplHTMLCode4Send
}

function setIframeHeightFromIframeContentHeight(iframe: HTMLIFrameElement) {
      iframe.style.opacity = '1';
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
}

function apiRequest(): Promise<Response> {
      const guid = Guid.getGuidFromUrl()
      return fetch(`https://jaffawebapisandbox.amax.co.il/API/LandingPage/GetRegistrationHtmlPage?guid=${guid}`, {
            method: 'GET',
            headers: {
                  'Content-Type': 'application/json',
            }
      })
}


initAppContent()



